var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCartLinedMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_949_186)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 3C4.25 2.58579 4.58579 2.25 5 2.25C7.55219 2.25 8.90034 3.71395 9.42371 4.85H31C31.2224 4.85 31.4333 4.9487 31.5758 5.11944C31.7183 5.29018 31.7777 5.51536 31.7379 5.73416L29.1427 20.0075C29.0906 20.3708 28.7781 20.65 28.4004 20.65H9.20039C8.1369 20.65 7.43038 20.8846 7.00797 21.2041C6.61256 21.5031 6.40039 21.9238 6.40039 22.5C6.40039 23.0763 6.61256 23.4969 7.00797 23.796C7.43038 24.1155 8.1369 24.35 9.20039 24.35H14.7342C14.7398 24.35 14.7453 24.35 14.7508 24.35C14.7563 24.35 14.7618 24.35 14.7673 24.35H27.7342C27.7398 24.35 27.7453 24.35 27.7508 24.35C29.2419 24.35 30.4508 25.5588 30.4508 27.05C30.4508 28.5411 29.2419 29.75 27.7508 29.75C26.2596 29.75 25.0508 28.5411 25.0508 27.05C25.0508 26.6189 25.1518 26.2115 25.3314 25.85H17.1701C17.3498 26.2115 17.4508 26.6189 17.4508 27.05C17.4508 28.5411 16.242 29.75 14.7508 29.75C13.2596 29.75 12.0508 28.5411 12.0508 27.05C12.0508 26.6189 12.1518 26.2115 12.3314 25.85H9.20039C7.94429 25.85 6.8758 25.5768 6.10312 24.9923C5.30343 24.3875 4.90039 23.5081 4.90039 22.5C4.90039 21.4919 5.30343 20.6126 6.10312 20.0077C6.8758 19.4233 7.94429 19.15 9.20039 19.15H10.6013L8.16697 5.76096C8.00317 5.14929 7.16602 3.75 5 3.75C4.58579 3.75 4.25 3.41421 4.25 3ZM9.79866 6.35L12.1259 19.15H27.7741L30.1013 6.35H9.79866Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_949_186",
    x: -2,
    y: -2,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_949_186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_949_186",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCartLinedMain);
export default __webpack_public_path__ + "static/media/ic_cart_lined_main.2c7882ee9f7aa1829745394718fd49df.svg";
export { ForwardRef as ReactComponent };